// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1xZYT","row":"ProcedureTreatmentSummary_row__3LjXh"};